import React, { useEffect, useState } from 'react';
import { PaspampresLogo } from './PaspampresLogo';
export function ClassificationBanner() {
  const [time, setTime] = useState('');
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const wibTime = new Intl.DateTimeFormat('id-ID', {
        timeZone: 'Asia/Jakarta',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(now);
      setTime(`${wibTime} WIB`);
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);
  const sep = ' // ';
  return <div className="flex h-7 sm:h-8 w-full items-center justify-between border-b border-red-200 bg-red-50 px-2 sm:px-4 font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-red-700" data-id="element-333">
      <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-334">
        <PaspampresLogo size={20} className="size-4 sm:size-5 shrink-0" data-id="element-335" />
        <span className="font-bold text-red-700" data-id="element-336">RAHASIA</span>
        <span className="text-red-400 hidden sm:inline" data-id="element-337">{sep}</span>
        <span className="hidden sm:inline" data-id="element-338">PASPAMPRES · GARUDA SHIELD C4I</span>
        <span className="text-red-400 hidden md:inline" data-id="element-339">{sep}</span>
        <span className="hidden md:inline" data-id="element-340">EYES ONLY</span>
      </div>

      <div className="hidden md:flex items-center gap-2" data-id="element-341">
        <div className="relative flex size-2 items-center justify-center" data-id="element-342">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" data-id="element-343"></span>
          <span className="relative inline-flex size-1.5 rounded-full bg-emerald-500" data-id="element-344"></span>
        </div>
        <span className="text-emerald-700" data-id="element-345">SYSTEM OPERATIONAL</span>
      </div>

      <div className="flex items-center gap-2 sm:gap-4" data-id="element-346">
        <span data-id="element-347">{time}</span>
        <div className="flex items-center gap-1.5 sm:gap-2 rounded bg-amber-100 px-1.5 sm:px-2 py-0.5 text-amber-700 border border-amber-200" data-id="element-348">
          <span className="size-1.5 rounded-full bg-amber-500" data-id="element-349"></span>
          <span className="hidden sm:inline" data-id="element-350">THREAT LEVEL: </span>WASPADA
        </div>
      </div>
    </div>;
}